import { render, staticRenderFns } from "./SourceRequestHistory.vue?vue&type=template&id=2c79041d&scoped=true&"
import script from "./SourceRequestHistory.vue?vue&type=script&lang=js&"
export * from "./SourceRequestHistory.vue?vue&type=script&lang=js&"
import style0 from "./SourceRequestHistory.vue?vue&type=style&index=0&id=2c79041d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c79041d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VDataTable})
